import { render, staticRenderFns } from "./goalList.vue?vue&type=template&id=7ccf38dd&scoped=true"
import script from "./goalList.vue?vue&type=script&lang=js"
export * from "./goalList.vue?vue&type=script&lang=js"
import style0 from "./goalList.vue?vue&type=style&index=0&id=7ccf38dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf38dd",
  null
  
)

export default component.exports